import React from "react";
import { Route, Switch } from "react-router-dom";
import { RoleEnum } from "../../interfaces/Roles";
import routes from "./routes";

export interface AppRouterProps {
  role: RoleEnum;
}

const AppRouter: React.FC<Partial<AppRouterProps>> = ({ role }) => {
  return (
    <Switch>
      {routes[role || "default"].map((route) => (
        <Route {...route}></Route>
      ))}
    </Switch>
  );
};

export default AppRouter;
